// Components==============
import Button from 'components/UI/Button/Button';
import RichText from 'components/UI/RichText/RichText';
import Shade from 'components/UI/Shade/Shade';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useContext } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import { GlobalAlertContext } from 'utilities/GlobalContext/GlobalAlert';
import './Alert.module.scss';
// =========================

export default function Alert() {
  const { alert, setAlert, customTitle } = useContext(GlobalAlertContext);

  return (
    <AnimatePresence>
      {alert && (
        <>
          <motion.div styleName="wrapper" {...framerFade}>
            <h1>{customTitle || 'Oops...'}</h1>
            {(alert as string)[0] === '<' ? (
              <RichText content={alert} />
            ) : (
              <p>{alert}</p>
            )}
            <Button onClick={() => setAlert('')}>Oké!</Button>
          </motion.div>
          <Shade onClick={() => setAlert('')} />
        </>
      )}
    </AnimatePresence>
  );
}
